import { Component, Input } from "@angular/core";

@Component({
  selector: "uni-summary-header",
  templateUrl: "./summary-header.component.html",
  styleUrls: ["./summary-header.component.scss"],
})
export class UniSummaryHeaderComponent {
  /**
   * Specify if need show one or two elements by row
   */
  @Input() public alignment: "inline" | "block" = "inline";

  /**
   * The theme of the header to use
   */
  @Input() public color: "primary" | "gray" = "gray";
}
